__turbopack_context__.v({
  "actionRow": "PlaylistPage-module___oLyka__actionRow",
  "container": "PlaylistPage-module___oLyka__container",
  "cover": "PlaylistPage-module___oLyka__cover",
  "coverWrapper": "PlaylistPage-module___oLyka__coverWrapper",
  "description": "PlaylistPage-module___oLyka__description",
  "emptyState": "PlaylistPage-module___oLyka__emptyState",
  "icon": "PlaylistPage-module___oLyka__icon",
  "info": "PlaylistPage-module___oLyka__info",
  "playButton": "PlaylistPage-module___oLyka__playButton",
  "title": "PlaylistPage-module___oLyka__title",
});
